<template>
  <div>
    <div id="sidebar-wrapper">
      <div class="text-center" id="logo-area">
        <img src="@/assets/images/brand/logo.png" alt="Findus logo" />
      </div>

      <div
        class="d-flex flex-column justify-content-between mt-4"
        id="nav-container"
      >
        <div id="top-nav">
          <ul class="nav flex-column">
            <li class="nav-item">
              <router-link
                class="d-flex align-items-center nav-link py-3"
                :to="{ name: 'DashboardPage' }"
              >
                <span>Archivio</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="role === 'amministratore'">
              <a
                class="d-flex align-items-center nav-link gestione py-3"
                :class="!showSubmenu ? 'collapsed' : ''"
                data-bs-toggle="collapse"
                @click="toggleSubmenu()"
              >
                <span>Gestione</span>
              </a>
              <div
                :class="!showSubmenu ? 'collapse' : ''"
                id="submenu"
                aria-expanded="false"
              >
                <ul class="flex-column pl-2 nav">
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'UsersPage' }"
                    >
                      <span>Utenti</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsTemporaryUrlsPage' }"
                    >
                      <span>Link di Condivisione</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsBrandPage' }"
                    >
                      <span>Brand</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsTipologiePage' }"
                    >
                      <span>Tipologie</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsCategoriePage' }"
                    >
                      <span>Categorie</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsTagPage' }"
                    >
                      <span>Tag</span>
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="d-flex align-items-center nav-link py-3"
                      :to="{ name: 'CmsAnniPage' }"
                    >
                      <span>Anni</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div id="bottom-nav">
          <div class="mt-4">
            <ul class="nav flex-column">
              <li class="nav-item cursor-pointer">
                <a
                  class="d-flex align-items-center nav-link py-3"
                  @click="logout()"
                >
                  <span>Log out</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showSubmenu: false,
    };
  },
  computed: {
    ...mapGetters("currentUser", ["role"]),
  },
  methods: {
    toggleSubmenu() {
      this.showSubmenu = !this.showSubmenu;
    },

    logout() {
      this.$store.dispatch("currentUser/logout");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";
@import "src/assets/scss/fonts";

#sidebar-wrapper {
  background: $sidebar-color;
  height: 100vh;
  width: $sidebar-width;
  position: fixed;
  top: 0;
  left: 0;

  #logo-area {
    padding-top: 20px;

    img {
      width: 50%;
    }
  }

  #nav-container {
    height: 80vh;

    span {
      font-family: $mulish;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #a4a6b3;
      padding-left: 20px;
    }

    #bottom-nav {
      border-top: 1px solid #dfe0eb;
    }

    .active {
      border-left: 3px solid #dde2ff;
      background-color: rgba(159, 162, 180, 0.08);

      span {
        color: #fff;
      }

      img {
        filter: brightness(0) invert(1);
      }
    }

    .nav-link:hover {
      background-color: rgba(159, 162, 180, 0.08);

      span {
        color: #fff;
      }

      img {
        filter: brightness(0) invert(1);
      }
    }

    #footer-nav {
      p {
        font-family: $inter;
        font-style: normal;
        font-weight: normal;
        font-size: 11.5745px;
        line-height: 14px;
        color: #ffffff;
      }

      #publish {
        button {
          width: 120px;
          height: 28px;
          font-family: $inter;
          font-style: normal;
          font-weight: normal;
          font-size: 11.574px;
          line-height: 14px;
          color: #ffffff;
          margin-bottom: 5px;
        }
      }
    }

    .cursor-pointer {
      cursor: pointer;
    }
  }

  #submenu {
    ul {
      .nav-link {
        &.active {
          padding-left: 11px !important;
        }
      }

      span {
        padding-left: 40px !important;
      }
    }
  }

  .gestione {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue